/* Herbal Synergies — wireframe-system behaviour (FAQ accordion + reveal).
   Mirrors the shared script in the HS Website Wireframes, scoped to .hs-wf. */
(function () {
  if (window.__hsWireInit) return;
  window.__hsWireInit = true;

  function init() {
    /* read-more expanders — the copy is server-rendered visible for crawlers
       and no-JS visitors; JS collapses it on load and reveals the toggle */
    document.querySelectorAll('.hs-wf .read-more-btn').forEach(function (btn) {
      if (btn.dataset.hsBound) return;
      btn.dataset.hsBound = '1';
      var more = document.getElementById(btn.getAttribute('aria-controls'));
      if (!more) return;
      more.setAttribute('hidden', '');
      btn.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var opening = more.hasAttribute('hidden');
        if (opening) { more.removeAttribute('hidden'); } else { more.setAttribute('hidden', ''); }
        btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
        btn.textContent = opening ? 'Read less' : 'Read more';
      });
    });

    /* FAQ accordions */
    document.querySelectorAll('.hs-wf .faq').forEach(function (f) {
      if (f.dataset.hsBound) return;
      f.dataset.hsBound = '1';
      var q = f.querySelector('.faq-q');
      var a = f.querySelector('.faq-a');
      if (!q || !a) return;
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var open = f.classList.contains('open');
        if (open) {
          f.classList.remove('open');
          a.style.maxHeight = null;
          q.setAttribute('aria-expanded', 'false');
        } else {
          f.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 20 + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* reveal on scroll (CSS already no-ops under prefers-reduced-motion) */
    var els = document.querySelectorAll('.hs-wf .rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (s) { s.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function (s) { io.observe(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
